import React, { useState, useEffect } from 'react';
import styles from './LoginRegister.scss';
// import { IPropertyWizardInput } from './NewPropertyWizard';
import useUser, { IUserState } from '../../stores/useUser';
// import styles from './NewPropertyWizard.scss';
import Owner from '../../utils/Owner';
import LoginRegisterToggle from '../LoginRegisterToggle';
import { IStep } from './ValuationSteps';
import trackApi, { IWglEventProps } from '../../utils/trackApi';

// export interface ILoginRegisterProps extends IPropertyWizardInput {
//     // text: string;
// }
export interface ILoginRegisterProps {
    // text: string;
    onChange: (name: IStep['name'], value: string | boolean) => void;
    trackingEvent?: IWglEventProps;
}

const LoginRegister: React.FC<React.PropsWithChildren<ILoginRegisterProps>> = ({ onChange = () => { }, trackingEvent }) => {
    const [user, userActions] = useUser();
    const [isLogin, setIsLogin] = useState(false);

    // useEffect(() => {
    //     if (user.isLoggedIn) {
    //         trackApi.wglTarget('DASHBOARD');
    //     }
    // }, []);

    useEffect(() => {
        // if (!data.contact) {
        //     Owner(user.id)
        //         .getContact()
        //         .then((data) => {
        //             onChange('contact', data);
        //         });
        // }
        onChange('loggedIn', user.isLoggedIn);
    }, [user]);

    // for tracking
    const handleSuccess = () => {
        // on register
        // if (!isLogin) {
        //   trackApi
        //     .event('Registrierung', 'Account', 'Eigentuemer')
        //     .then(() => {})
        //     .catch((e) => {
        //         console.error('ga error', e);
        //     });
        // }
        // trackApi.wglTarget('DASHBOARD');
    };

    // const handleChange = (ev: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
    //     onChange(ev.target.name as keyof IProperty, ev.target.value);
    // };

    // const handleRegister = () => {
    //     onChange('loggedIn', true);
    // };

    return (
        <div className={styles.valuationLoginRegister}>
            {user.isLoggedIn ? (
                <div>Eingeloggt als {user.name}</div>
            ) : (
                <>
                    {isLogin ? (
                        <>
                            <a
                                onClick={() => {
                                    setIsLogin(false);
                                }}
                            >
                                » Neuen Account registrieren
                            </a>
                        </>
                    ) : (
                        <>
                            Du bist bereits registriert?
                            <br />
                            <a
                                onClick={() => {
                                    setIsLogin(true);
                                }}
                            >
                                » Mit bestehendem Account anmelden
                            </a>
                            <p>
                                oder <b>neu Registrieren</b>:<br />
                                <span className={styles.description}>
                                    Damit Du Deine Immobilie langfristig beobachten kannst, brauchen wir Deine E-Mail-Adresse, damit wir Deine Immobilie einem
                                    Account zuweisen können.
                                </span>
                            </p>
                        </>
                    )}
                    <LoginRegisterToggle
                        successHandler={handleSuccess}
                        className={isLogin ? styles.login : styles.register}
                        showMinimal={true}
                        defaultForm={isLogin ? 'login' : 'register'}
                        trackingEvent={trackingEvent}
                    />
                </>
            )}
        </div>
    );
};

export default LoginRegister;
